/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

/**
 * Component.
 */
@Component({ name: 'status-to-collect-in-service-point-component' })
export default class extends Vue {
  /**
   * Property `timer`.
   */
  timer = null;

  /**
   * Property `windowHeight`;
   */
  windowHeight = null;

  /**
   * Property `client`.
   */
  @Prop({ type: String })
  client: string;

  /**
   * Property `servicePoint`.
   */
  @Prop({ default: null, type: String })
  servicePoint: string;

  /**
   * Getter status title.
   */
  get statusTitle() {
    return this.i18n('TRACKING.SENTENCES.STATUS_HELLO', false, 'upperFirst', {
      name: this.client || '-'
    });
  }

  /**
   * Getter status sentence.
   */
  get statusSentence() {
    const { servicePoint = null } = this || {};

    const message = this.i18n(
      'TRACKING.SENTENCES.STATUS_COLLECT_IN_SERVICE_POINT',
      false,
      'plain',
      { name: `<b>${servicePoint || '-'}</b>` }
    );

    return message;
  }

  /**
   * Getter `extraSmallScreenHeight`.
   */
  get extraSmallScreenHeight() {
    return this.windowHeight <= 320;
  }

  /**
   * Lifecycle mounted hook.
   */
  mounted() {
    this.handleOnResize();

    this.$nextTick(() => {
      window.addEventListener('resize', this.handleOnResize);
    });
  }

  /**
   * Lifecycle destroyed hook.
   */
  destroyed() {
    clearInterval(this.timer);
    window.removeEventListener('resize', this.handleOnResize);
  }

  /**
   * Handle on resize.
   */
  handleOnResize() {
    this.windowHeight = window.innerHeight;
  }

  /**
   * Handle window height.
   */
  @Watch('windowHeight')
  handlewindowHeight(value) {
    this.windowHeight = value;
  }
}
